// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';

export class CompetitorInfo {
  readonly id: string;
  readonly name: string;
  readonly isArchived: boolean;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.name = data.name === undefined ? '' : data.name;
    this.isArchived = data.isArchived === undefined ? false : data.isArchived;
  }

  static zero(): CompetitorInfo {
    const zeroValues: ExcludeMethodsDeep<CompetitorInfo> = {
      id: NIL_UUID,
      name: '',
      isArchived: false,
    };
    return new CompetitorInfo(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type CompetitorInfoWireFormat = {
  id: string;
  name: string;
  isArchived: boolean;
};

type NewCompetitorInfoProps = PartialDeep<CompetitorInfo, { recurseIntoArrays: true }>;
export const NewCompetitorInfo: (props: NewCompetitorInfoProps) => CompetitorInfo = (props) =>
  new CompetitorInfo(props);

type NewCompetitorInfoFromWireFormatProps = PartialDeep<
  CompetitorInfoWireFormat,
  { recurseIntoArrays: true }
>;
export const NewCompetitorInfoFromWireFormat: (
  props: NewCompetitorInfoFromWireFormatProps,
) => CompetitorInfo = (props) => new CompetitorInfo(props);
